/**
 . An enum used:
 . to identify a widget in the iframe-based widgets framework
 . as prefix to store cookies for a widget; e.g. states
 */
const WidgetTypes = Object.freeze({
    DropDown: 'apexchat_dropdown_invitation',
    Bar: 'apexchat_bar_invitation',
    Tab: 'apexchat_tab_invitation',
    SMS: 'apexchat_sms_invitation',
    Static: 'apexchat_static_button',
    ExitPopup: 'apexchat_exitpopup2_chatwindow',
    DOM: 'apexchat_dompopup_chatwindow',
    Windowed: 'apexchat_browser_chatwindow',
    Mobile: 'apexchat_mobile_dom_chatwindow',
    ChatRoom: 'apexchatroom',
    DOMUIController: 'apexchat_dom_ui_controller',
    EPUIController: 'apexchat_ep_ui_controller',
    // MessageHandler: used for classical msgs styling
    MessageHandler: 'apexchat_msg_handler',
    // PreChatMessageHandler: for rounded stylish msgs styling
    PreChatMessageHandler: 'apexchat_prechat_msg_handler',
    PreChat: 'apexchat_prechat_invitation',
    VisitorForm: 'apexchat_ui_visitor_form',
    DynamicVisitorForm: 'apexchat_ui_dynamic_visitor_form',
    WebSmsForm: 'apexchat_sms_form',
    Test: 'apexchat_test_invitation',
    PokeMessagesOverLay: 'apexchat_poke_messages',
    VideoGreetInvitation: 'apexchat_video_greet_invitation',
    VideoGreetMessageHandler: 'apexchat_video_greet_msg_handler'
});

export default WidgetTypes;
